/* eslint class-methods-use-this: ["error", { "exceptMethods": ["onclick","unbind"] }] */

import throttle from 'lodash/throttle';

class ProductImpression {
  /**
   * constructor
   * @param el, dom elem on which add click event
   * @param binding params for tagging
   */
  constructor(el, binding) {
    this.tag = binding.value;
    this.element = el;
    this.scrollCallbackReference = null;
    this.bindElement();
  }

  bindElement() {
    /* istanbul ignore next */
    this.scrollCallbackReference = throttle(() => {
      if (this.isElementInViewport()) {
        this.sendImpression();
      }
    }, 500);
    window.addEventListener('scroll', this.scrollCallbackReference);
  }

  isElementInViewport() {
    const rect = this.element.getBoundingClientRect();

    const isInViewPort =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    return isInViewPort;
  }
  /**
   * handler on click to deliver tag
   */
  sendImpression() {
    try {
      dataLayer.push(this.tag);
    } catch {
      console.warn('datalayer is not defined');
    }

    /* istanbul ignore if */
    if (this.scrollCallbackReference) {
      this.unbind();
    }
  }

  /**
   *
   * @param el
   */
  unbind() {
    window.removeEventListener('scroll', this.scrollCallbackReference);
  }

  /**
   * Install the global plugin for handle key issue on sitecore editor
   * @param Vue
   */
  static install(Vue) {
    let productImpression;
    Vue.directive('product-impression', {
      bind: (el, binding) => {
        productImpression = new ProductImpression(el, binding);
      },
      unbind: (el) => productImpression.unbind(el),
    });
  }
}

export default {
  install: (Vue) => ProductImpression.install(Vue),
  Instance: ProductImpression,
};
